<script lang="ts">
	import Icon from '../../components/Icon.svelte';
	import ContorlButton from './ContorlButton.svelte';

	//export let gameArray;
	export let movements;
	export let moveLeft;
	export let moveRight;
	export let moveUp;
	export let moveDown;
	export let winState: () => void = null;
	export let handleSelectNextCollection;

	const handleKeydown = (event) => {
		switch (event.key) {
			case 'ArrowDown':
				moveDown();
				break;
			case 'ArrowUp':
				moveUp();
				break;
			case 'ArrowRight':
				moveRight();
				break;
			case 'ArrowLeft':
				moveLeft();
				break;
			case 'Tab':
				handleSelectNextCollection();
				break;
		}
	};
</script>

<svelte:window on:keydown={handleKeydown} />

<div class="container" >
	<ContorlButton  {movements} moveDirection={handleSelectNextCollection} playerDidWin={winState}>
		button
	</ContorlButton>
<div id="buttons-wrapper">
	
	<ContorlButton {movements} moveDirection={moveLeft} playerDidWin={winState}>
		<div style="transform: rotateZ(-180deg);">
			<Icon name="left" width={30} height={30} color={'#16123f'} />
		</div>
	</ContorlButton>
	<div class="up-down-wrapper">
		<ContorlButton {movements} moveDirection={moveUp} playerDidWin={winState}>
			<div style="transform: rotateZ(-90deg);">
				<Icon name="left" width={30} height={30} color={'#16123f'} />
			</div>
		</ContorlButton>

		<ContorlButton {movements} moveDirection={moveDown} playerDidWin={winState}>
			<div style="transform: rotateZ(90deg);">
				<Icon name="left" width={30} height={30} color={'#16123f'} />
			</div>
		</ContorlButton>
	</div>
	<ContorlButton {movements} moveDirection={moveRight} playerDidWin={winState}>
		<div style="transform: rotateZ(0deg);">
			<Icon name="left" width={30} height={30} color={'#16123f'} />
		</div>
	</ContorlButton>
	<!-- <button on:click={handleSelectNextCollection}>chooese</button> -->
</div>
</div>
<style>
	.container{
		width:100%;
		display: flex;
		flex-direction: column;
		position: relative;
		height: 100px;
		background-color: #75c9b7;
		color:#0b325e;
		top: 460px;
	}
	#buttons-wrapper {
		display: flex;
		justify-content: space-between;
		background-color: #75c9b7;
		width: 100%;
		box-shadow: inset 2px 5px 16px 0px #0b325e;
	}
	.up-down-wrapper {
		display: flex;
		flex-direction: column;
		background-color: #75c9b7;
		box-shadow: inset 2px 5px 16px 0px #0b325e;

		width: 100%;
	}
	/* .circle {
		background-color: red;
		border-radius: 20px;
		width: 20px;
		height: 20px;
	} */
</style>
